<template>
	<div class="content-class">
		<v-tabs color="black" dark slider-color="primary">
			<v-tab ripple>Paramètre par défaut</v-tab>
		</v-tabs>
		<default-parameters-list url="default-parameters" />
	</div>
</template>

<script>
import DefaultParametersList from '../../components/defaultParameters/defaultParameters.list'

export default {
	components: { DefaultParametersList },
}
</script>

<style lang="scss">
.content-class {
	width: 100%;
	height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/defaultParameters/defaultParameters.list.vue